// apps/conext-ventas/src/simulator/utils/workerUnits.js
// Fuente de verdad del cobro por trabajadores en UNIDADES de media jornada.
// Espejo ESM de aws_lambdas/_shared_billing/workerUnits.js — cualquier cambio
// va en los dos.
//
// Modelo: jornada completa = 2 unidades, media jornada = 1 unidad.
// La jornada se deriva del horario BASE de c_calendar_availability (se ignoran
// schedule_overrides y cierres festivos, o un cierre de verano convertiría a
// toda la plantilla en media jornada durante agosto).
//
// Los tramos están calibrados para que surchargeForUnits(2n) == el tramo
// histórico de n trabajadores a jornada completa (0,0,5,5,10,10 para n=1..6).
// Romper eso sube la factura a clientes existentes.

export const HALF_TIME_MAX_WEEKLY_HOURS = 25; // 0 < h <= 25 → media jornada
export const MAX_BILLABLE_UNITS = 12; // > 12 → contactar ventas
export const FULL_TIME_UNITS = 2;
export const HALF_TIME_UNITS = 1;

// [maxUnidades, recargoEuros] — el primero cuyo maxUnidades >= units manda.
export const UNIT_TIERS = [
  [4, 0],
  [5, 2.5],
  [8, 5],
  [9, 7.5],
  [12, 10],
];

function parseMinutes(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || "").trim());
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  if (h > 23 || min > 59) return null;
  return h * 60 + min;
}

// Suma las horas semanales del horario base. Las pausas no se guardan (el
// formulario las filtra antes de enviar), así que todo tramo guardado es
// trabajo efectivo.
export function weeklyHours(schedule) {
  let obj = schedule;
  if (typeof obj === "string") {
    try {
      obj = JSON.parse(obj);
    } catch {
      return 0;
    }
  }
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return 0;

  let minutes = 0;
  for (const slots of Object.values(obj)) {
    if (!Array.isArray(slots)) continue;
    for (const slot of slots) {
      const start = parseMinutes(slot?.start);
      const end = parseMinutes(slot?.end);
      if (start === null || end === null || end <= start) continue;
      minutes += end - start;
    }
  }
  return minutes / 60;
}

// 0 h → "full" a propósito: un trabajador recién creado nace sin horario, y si
// 0 h contara como media, cada alta infracobraría hasta que alguien se lo pusiera.
export function classifyWorker(hours) {
  const h = Number(hours) || 0;
  return h > 0 && h <= HALF_TIME_MAX_WEEKLY_HOURS ? "half" : "full";
}

export function unitsForWorker(schedule) {
  return classifyWorker(weeklyHours(schedule)) === "half"
    ? HALF_TIME_UNITS
    : FULL_TIME_UNITS;
}

// workerIds: array de user_id (sin "admin").
// schedulesByUserId: { [user_id]: scheduleObjectOrJsonString }. Un id que falte
// cuenta como jornada completa.
export function computeUnits(workerIds, schedulesByUserId = {}) {
  if (!Array.isArray(workerIds)) return 0;
  return workerIds.reduce(
    (sum, id) => sum + unitsForWorker(schedulesByUserId[id]),
    0,
  );
}

// Recargo mensual en euros. null = por encima del máximo → contactar ventas.
export function surchargeForUnits(units) {
  const u = Math.max(0, Math.floor(Number(units) || 0));
  for (const [maxUnits, surcharge] of UNIT_TIERS) {
    if (u <= maxUnits) return surcharge;
  }
  return null;
}
